export default __webpack_public_path__ + "static/media/logo-dark.49db1052.svg";